import { BeBarberPole, BeProgressBar, BeStack } from "@beos-css/react/index.ts";
import { useEffect, useState } from "react";

export function ProgressBarDemo() {
	const [progress, setProgress] = useState(0);

	useEffect(() => {
		const id = setInterval(() => {
			setProgress((p) => (p >= 100 ? 0 : p + 2));
		}, 120);
		return () => clearInterval(id);
	}, []);

	return (
		<>
			<section id="demo-progress-bar">
				<h3>Regular (BStatusBar)</h3>
				<p>
					The R5 <em>determinate</em> progress bar — a recessed trough with a blue raised fill.
				</p>
				<BeStack gap="label" className="demo-narrow">
					<BeProgressBar label="Copying…" value={progress} trailing={`${progress}%`} />
					<BeProgressBar label="Downloading" value={25} trailing="25%" />
					<BeProgressBar value={100} trailing="Done" />
				</BeStack>
			</section>

			<section id="demo-barber-pole">
				<h3>Indeterminate (Barber pole)</h3>
				<p>
					The <em>indeterminate</em> barber pole (Zip-O-Matic / live-query motif): animated blue/white diagonal stripes in a convex 3D tube.
					BeOS has no indeterminate <code>BStatusBar</code>, so the pole is the faithful stand-in.
				</p>
				<BeStack gap="label" className="demo-narrow">
					<BeBarberPole label="Working" aria-label="Working" />
					<BeBarberPole state="paused" label="Paused (reduced motion)" aria-label="Paused" />
					<BeBarberPole state="idle" label="Idle" aria-label="Idle" />
				</BeStack>
				<BeStack gap="label" className="demo-narrow">
					<BeBarberPole label="Searching…" trailing="Please wait" />
					<BeBarberPole state="paused" label="Indexing" trailing="Paused" />
				</BeStack>
			</section>
		</>
	);
}
